import React, { useState, useEffect } from 'react';

import api from '../../services/api';
import './styles.css';

function HandleMovimentacao() {
    const [movs, setMovs] = useState([]);

    useEffect(() => {
        api.get('fluxo').then(response =>{
            setMovs(response.data);
            console.log(response);
        });
    }, []);

    return(
        <>
            <table id="mov">
                <tr>
                    <th>Descrição</th>
                    <th>Valor</th>
                    <th>Tipo</th>
                    <th>Data</th>
                </tr>
                <tbody>
                    {movs.map(mov => (
                        <tr key={mov.id}>
                            <td>{mov.description}</td>
                            <td>{new Intl.NumberFormat('pt-br', {
                                style: 'currency',
                                currency: 'BRL'})
                                .format(mov.value)}
                            </td>
                            <td>{mov.type === "E" ? "Entrada" : "Saída"}</td>
                            <td>{mov.date}</td>
                        </tr>
                    ))}
                </tbody>
            </table>
        </>
    );
}

export default HandleMovimentacao;